export const ProcessadoraCartaoEnum = [
  { value: "NENHUMA", label: "Nenhuma Processadora Cartão" },
  { value: "ORBITAL", label: "Orbitall" }
]